import { useState, useEffect } from 'react';
import { ProductLine } from '@adc/constants';
import configment from '@adc/configment';
const useProductLineFromHost = () => {
    const [productLine, setProductLine] = useState(null);
    useEffect(() => {
        const determineProductLine = () => {
            if (configment.get('AUCTIONCOM_HOST', '') === window.origin) {
                return ProductLine.AuctionCom;
            }
            if (configment.get('SMARTSALE_HOST', '') === window.origin) {
                return ProductLine.SmartSale;
            }
            return null;
        };
        setProductLine(determineProductLine());
    }, []);
    return productLine;
};
export default useProductLineFromHost;
//# sourceMappingURL=index.js.map